import { Component } from 'react';
//
export default class CustomComponent extends Component {
  constructor(props) {
    super(props);
    this._isMounted = true;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  // Util
  startLoading() {
    this.setState({ isLoading: true });
  }

  stopLoading(shouldRender = true) {
    this.setState({ isLoading: false });
    if (shouldRender) this.setState(this.state);
  }
}
